module.exports = __webpack_public_path__ + "static/media/pin.b5cacb96.gif";